import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui } from "@ryde/theme";

export const RideTabsBottomBlocksStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-tabs-bottom",
})`
  margin-top: auto;
  padding-bottom: 14px;
  padding-inline-start: 22px;
  display: flex;
  flex-direction: column;
`;

export const RideTabsBottomBlocksHeaderStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-tabs-bottom-blocks-header",
  },
)`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
`;

export const RideTabsBottomBlocksExpandPanelStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-tabs-bottom-blocks-expand-panel",
  },
)`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  padding-top: 6px;
  row-gap: 8px;
`;

export const RideTabsBottomExpandToggleStyled = styled.button.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-tabs-bottom-expand-toggle",
    type: "button",
  },
)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 1px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${greyMui._500};
  line-height: 0;
  border-radius: 2px;
  flex-shrink: 0;
  vertical-align: baseline;

  &:hover {
    color: ${blueGreyMui._700};
  }

  &:focus-visible {
    outline: 2px solid ${blueGreyMui._400};
    outline-offset: 1px;
  }

  svg {
    width: 10px;
    height: 10px;
    opacity: 0.85;
  }

  &:hover svg {
    opacity: 1;
  }
`;
